@import (reference) '../../../../../constants/spacing.module.less';

.items-table-sub-row {
  text-align: left;
  line-height: 18px;
  padding: @space-8 @space-16;
  overflow-wrap: anywhere;
}

.attribute-row-toggle {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.caret {
  align-items: center;

  > svg {
    width: 7.5px;
    height: 12px;
  }
}
